export const signatureKeys = {
  signature: () => ['SIGNATURE'] as const,
};
